import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { MAT_DIALOG_DATA, MatAutocompleteTrigger, MatDialog, MatDialogRef } from '@angular/material';
import { ActivatedRoute } from '@angular/router';
import * as _ from 'lodash';
import * as moment from 'moment';
import { ToastrService } from 'ngx-toastr';
import { finalize } from 'rxjs/operators';
import { CommonService } from 'src/app-core/services/common.service';
import { ContactService } from 'src/app/contacts/contact.service';
import { JobsService } from 'src/app/jobs/jobs.service';
import { VehiclesService } from 'src/app/vehicles/vehicles.service';
import { CommonDataModel } from '../common-data-model';
import { CommonConstants } from 'src/app-core/constants/common-constants';

@Component({
    selector: 'app-appointment-form',
    templateUrl: './appointment-form.component.html',
    styleUrls: ['./appointment-form.component.scss']
})
export class AppointmentFormComponent implements OnInit {
    @ViewChild('matContactAutocomplete', { read: MatAutocompleteTrigger, static: false }) contactAutoComplete: MatAutocompleteTrigger;
    @ViewChild('matJobAutocomplete', { read: MatAutocompleteTrigger, static: false }) matJobAutocomplete: MatAutocompleteTrigger;
    @ViewChild('appointmentForm', { static: false }) appointmentForm: NgForm;
    commonModel = new CommonDataModel();
    isFormLoading = false;
    tempAappointmentData: any;
    appointmentData = this.commonModel.appointmentFormModel;
    driverList: any;
    contacts: any;
    employees: any = [];
    appointmentTypes = this.commonModel.appointmentTypesModel;
    vehicleList: Array<any>;
    startTime: any;
    endTime: any;
    orderDetails: any;
    contactListOriginal: any;
    assignedTo = 0;

    timePickerSteps = this.commonModel.orderAppointmentTimePickerSteps;
    minOperationEndTime: any;
    minOperationStartTime: any;
    isDateDisabled = false;
    minDate = moment().format();
    jobList = [];
    isShowSaveButton = true;
    orderIdTitle = CommonConstants.appComponent.job;

    constructor(
        public dialog: MatDialog,
        public dialogRef: MatDialogRef<AppointmentFormComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any,
        private commonService: CommonService,
        private contactService: ContactService,
        private vehiclesService: VehiclesService,
        private toastr: ToastrService,
        private jobsService: JobsService,
        private activatedRoute: ActivatedRoute) {
        if (this.activatedRoute.snapshot.queryParams.quoteId) {
            this.orderIdTitle = CommonConstants.appComponent.quote;
        }
    }

    ngOnInit() {
        window.addEventListener('scroll', this.autoCompleteScrollEvent, true);
        this.isShowSaveButton = true;
        this.tempAappointmentData = this.data;
        if (this.tempAappointmentData && this.tempAappointmentData.calendarCurrentView) {
            this.isDateDisabled = this.tempAappointmentData.calendarCurrentView;
        }
        this.timePickerSteps = { hour: 0, minute: 15, second: 30 };
        this.getAppointmentTypes();
        this.onChangeJob('');
        this.getDrivers();
        this.getVehicles();
        this.contactListOriginal = _.cloneDeep(this.contacts);
        this.orderDetails = this.data.orderDetails;

        if (this.data.isEdit && this.data.appointmentDetails) {
            this.commonService.objectMapping(this.appointmentData, this.data.appointmentDetails);
            this.appointmentData.orderDisplayId = this.data.appointmentDetails.jobId;
            this.appointmentData.orderId = this.data.appointmentDetails.orderLongId;
            this.appointmentData.orderGuid = this.data.appointmentDetails.orderId;
            this.appointmentData.startTime = this.data.appointmentDetails.start;
            this.appointmentData.endTime = this.data.appointmentDetails.end;
            this.assignedTo = this.data.appointmentDetails.employeeId;
            this.minOperationStartTime = this.appointmentData.startTime;
            this.setMinTimeForEndTime();
            if (moment().format() > moment(this.appointmentData.startTime).format()) {
                this.isShowSaveButton = false;
            }
            this.contactList(this.data.appointmentDetails.orderLongId);
            this.getEmployees();
        } else {
            if (this.data.orderDetails) {
                this.appointmentData.orderDisplayId = this.data.orderDetails.displayId;
                this.appointmentData.orderId = this.data.orderDetails.id;
                this.appointmentData.orderGuid = this.data.orderDetails.orderId;
            }
            this.appointmentData.startTime = moment().format();
            this.appointmentData.endTime = moment().add(15, 'minutes').format();
            this.minOperationStartTime = moment().format();
            this.contactList();
            this.getEmployees();
            // this.appointmentData.startTime =
            // this.commonService.getDateObjectFromTimeString('00:00:00');
            // this.appointmentData.endTime =
            // this.commonService.getDateObjectFromTimeString('00:15:00');
        }


        // this is for If user click on clander on perticular date & time so it's will default selected in form
        if (this.tempAappointmentData && this.tempAappointmentData.start) {
            this.appointmentData.appointmentDate = this.tempAappointmentData.start;
            this.appointmentData.startTime = this.tempAappointmentData.start;
            this.appointmentData.endTime = this.tempAappointmentData.end;
        } else {
            if (!this.data.isEdit) {
                this.appointmentData.appointmentDate = new Date();
            }
        }
        // this.setMinTimeForEndTime();

        // used in get details Integration
        // this.tempAappointmentData = this.data;
        // this.appointmentData = this.data;
        // if (this.appointmentData.id) {
        //   this.appointmentData = this.data;
        // } else {
        //   this.appointmentData = this.commonModel.appointmentFormModel;
        //   if (this.tempAappointmentData && this.tempAappointmentData.start) {
        //     this.appointmentData.appointmentDate = this.tempAappointmentData.start;
        //   }
        // }
    }

    onChangeJob(searchText: any): void {
        const searchQuery = `SearchQuery=${(searchText && searchText.orderDisplayId) ? searchText.orderDisplayId : searchText}`;
        this.jobsService.getJobLookup(searchQuery).subscribe(response => {
            this.jobList = response.data;
        });
    }

    onBindJobName(item?: any): string | undefined {
        return item ? item.orderDisplayId : undefined;
    }

    onSetJobDetails(job: any): void {
        if (job && job.orderId) {
            this.appointmentData.orderId = job.id;
            this.appointmentData.orderGuid = job.orderId;
            this.appointmentData.orderDisplayId = job.orderDisplayId;
            this.contactList(job.id);
        }
    }

    onSelectJobName(value: any) {
        this.appointmentData.orderDisplayId = value ? value.orderDisplayId : '';
        this.onBindJobName(value);
    }

    onClearJobSelected(event?: any) {
        this.appointmentData.orderId = null;
        this.appointmentData.orderDisplayId = null;
        this.onChangeJob('');
        this.contactList('');
    }

    onChangeAppointment(appointment) {
        this.appointmentData.appointmentTypeId = appointment.id;
        this.appointmentForm.form.markAsDirty();
    }

    onBindContact(item: any): string | undefined {
        return item.name;
    }


    contactList(callFrom?: any): void {
        this.contacts = [];
        let searchQuery = '';
        if (callFrom) {
            searchQuery += `OrderId=${callFrom}`;
        } else if (this.orderDetails) {
            searchQuery += `OrderId=${this.orderDetails.id}`;
        }
        this.commonService.getOrderContacts(searchQuery).subscribe(response => {
            if (response.isSuccess) {
                this.contacts = response.data;
                if (this.appointmentData.contactId) {
                    const findSelected = this.contacts.find(contact => contact.contactId === this.appointmentData.contactId);
                    (!findSelected) ? this.appointmentData.contactId = null : '';
                }
            }
        });
    }

    onChangeDate(event: any) {
        this.appointmentData.appointmentDate = moment(event.value).format();
        if ((new Date(this.appointmentData.appointmentDate) > (new Date(moment().format())))) {
            this.minOperationStartTime = null;
        } else {
            this.minOperationStartTime = moment().format();
        }
    }

    onSetContactDetails(contact: any): void {
        if (contact) {
            this.appointmentData.contactId = contact.contactId;
        }
    }

    onSelectContactName(value: any) {
        this.appointmentData.contactName = value ? value.fullName : '';
        this.onBindContactName(value);
    }

    getEmployees(): void {
        this.commonService.getEmployees(this.assignedTo || 0).subscribe(response => {
            if (response.isSuccess) {
                this.employees = response.data.filter(employee => employee.includeOnSchedule);
            }
        });
    }

    getVehicles(): void {
        this.vehiclesService.getVehicles().subscribe(response => {
            this.vehicleList = response.data;
        });
    }

    onVehicleChange(data: any) {
        if (data) {
            this.appointmentData.vehicleId = data.id;
            this.appointmentData.vehicleName = data.name;
        }
    }

    onDriverChange(data: any) {
        if (data) {
            this.appointmentData.driverId = data.driverId;
            this.appointmentData.driverName = data.driver;
        }
    }

    onEmployeeChange(data: any) {
        if (data) {
            this.appointmentData.employeeId = data.assignedTo;
            this.appointmentData.employeeName = data.employeeName;
        }
    }

    onContactChange(data: any) {
        if (data) {
            this.appointmentData.contactName = data.contactName;
        }
    }

    getAppointmentTypes() {
        this.commonService.getAppointmentTypes().subscribe(response => {
            this.appointmentTypes = response.data;
        });
    }

    getDrivers() {
        this.vehiclesService.getDrivers().subscribe(response => {
            if (response.isSuccess) {
                this.driverList = response.data;
            }
        });
    }

    onBindContactName(item?: any): string | undefined {
        return item ? item.fullName : undefined;
    }

    onSubmit() {
        const appointmentFormData = _.cloneDeep(this.appointmentData);
        if (this.orderDetails !== undefined && !appointmentFormData.orderId) {
            appointmentFormData.orderId = this.orderDetails.id;
        }
        appointmentFormData.startTime =
            this.commonService.getTimeStringFromDateObjectg(this.appointmentData.startTime);
        appointmentFormData.endTime =
            this.commonService.getTimeStringFromDateObjectg(this.appointmentData.endTime);
        appointmentFormData.appointmentDate = moment(appointmentFormData.appointmentDate).utcOffset(0, true).format();
        this.commonService.createAppointment(appointmentFormData).subscribe(response => {
            if (response.isSuccess) {
                this.toastr.success(response.errors);
                const sendingData = {
                    confirmResult: true,
                };
                this.dialogRef.close(sendingData);
            }
        });
    }

    onStartTimeChange(data: any) {
        this.setMinTimeForEndTime();
    }

    setMinTimeForEndTime() {
        const startDate = new Date(this.appointmentData.startTime);
        const date = new Date();
        let endTimeHoursStart = startDate.getHours();
        let endTimeMinutesStart = startDate.getMinutes() + 15;
        if (startDate.getMinutes() === 45) {
            endTimeHoursStart = startDate.getHours() + 1;
            endTimeMinutesStart = 0;
        }
        this.minOperationEndTime = new Date(date.getFullYear(), date.getMonth(), date.getDate(), endTimeHoursStart, endTimeMinutesStart);
        if (this.appointmentData.startTime >= new Date(this.appointmentData.endTime)) {
            this.appointmentData.endTime = this.minOperationEndTime;
        } else if (this.appointmentData.startTime.toTimeString() === this.appointmentData.endTime.toTimeString()) {
            this.appointmentData.endTime = this.minOperationEndTime;
        }
    }

    onClose(): void {
        this.dialogRef.close(false);
    }

    autoCompleteScrollEvent = (event: any): void => {
        if (event.target && event.target.className && event.target.className.indexOf('mat-autocomplete-visible') === -1) {
            if (this.contactAutoComplete && this.contactAutoComplete.panelOpen) {
                this.contactAutoComplete.closePanel();
            } else if (this.matJobAutocomplete && this.matJobAutocomplete.panelOpen) {
                this.matJobAutocomplete.closePanel();
            }
        }
    }

    onOpenJobsOption() {
        this.matJobAutocomplete.openPanel();
    }

    onRemove(dataItem: any) {
        this.commonService.getConfirmationPopup
            (CommonConstants.appointmentFormConstant.removeAppointmentConfirmation,
                CommonConstants.appComponent.cancel, CommonConstants.appComponent.confirm).then(result => {
                    if (result) {
                        const requestBody = {
                            appointmentId: dataItem.appointmentId,
                            isActive: false
                        };
                        this.isFormLoading = true;
                        this.commonService.deleteAppointment(requestBody)
                            .pipe(finalize(() => (this.isFormLoading = false)))
                            .subscribe((response: any) => {
                                if (response.isSuccess) {
                                    this.toastr.success(
                                        response.errors || CommonConstants.appointmentFormConstant.appointmentRemovedSuccessfully);
                                    const sendingData = {
                                        confirmResult: true,
                                    };
                                    this.dialogRef.close(sendingData);
                                } else {
                                    this.toastr.error(response.errors
                                        || CommonConstants.appComponent.somethingWenWrongPleaseReTry, CommonConstants.appComponent.error);
                                }
                                this.isFormLoading = false;
                            });
                    }
                });
    }

    onOpenContactOption() {
        this.contactAutoComplete.openPanel();
    }

}
